import React, { useEffect, useRef, useState } from 'react';
import URL from "utils/url";
import { PostRequestResolve } from '../../../utils/FetchHelper';
import { Card, Descriptions, Flex, Input, Row, Tag, Typography } from 'antd';
import _ from 'lodash';
import { Message } from '../../../variables/general';
import CustomButton from '../../../common/CustomButton/Button';

// updateProperties function call post request to update properties
const updateSamlProperties = (acctName, updatedSamlProperties) => {
    const payload = {
        acctName: acctName,
        samlProperties: updatedSamlProperties,
    };
    // Call post request to update properties
    PostRequestResolve(URL.updateSamlAccountProperties, null, payload)
        .then((response) => {
            Message.success("Properties updated successfully", _.get(response, "message"));
        }).catch((error) => {
            console.error("Failed to update properties", error);
            Message.error("Failed to update properties", error);
        });
};

// React Account Properties component
const AccountProperties = ({ properties, acctName }) => {
    const [samlProperties, setSamlProperties] = React.useState(_.get(properties, "samlProperties", {}));

    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [editInputIndex, setEditInputIndex] = useState(-1);
    const [editInputValue, setEditInputValue] = useState('');
    const inputRef = useRef(null);
    const editInputRef = useRef(null);
    useEffect(() => {
        if (inputVisible) {
            inputRef.current?.focus();
        }
    }, [inputVisible]);
    useEffect(() => {
        editInputRef.current?.focus();
    }, [editInputValue]);

    //   remove email from properties
    const handleClose = (removedEmail) => {
        const newEmails = _.filter(_.get(samlProperties, "emailDomains", []), (email) => email !== removedEmail);
        setSamlProperties({ ...samlProperties, emailDomains: newEmails });
    };
    const showInput = () => {
        setInputVisible(true);
    };
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };
    const handleInputConfirm = () => {
        const currentEmails = _.get(samlProperties, "emailDomains", []) || [];
        if (inputValue && !_.includes(currentEmails, inputValue)) {
            setSamlProperties({ ...samlProperties, emailDomains: [...currentEmails, inputValue] });
        }
        setInputVisible(false);
        setInputValue('');
    };
    const handleEditInputChange = (e) => {
        setEditInputValue(e.target.value);
    };
    const handleEditInputConfirm = () => {
        const currentEmails = _.get(samlProperties, "emailDomains", []) || [];
        const newEmails = [...currentEmails];
        newEmails[editInputIndex] = editInputValue;
        setSamlProperties({ ...samlProperties, emailDomains: newEmails });
        setEditInputIndex(-1);
        setEditInputValue('');
    };
    const tagPlusStyle = {
        height: 22,
        borderStyle: 'dashed',
    };

    const cdoProperties = _.get(properties, "cdoProperties", {});

    return (
        <Flex vertical gap="small">
            <Row style={{ width: "100%" }}>
                <Typography.Title level={4} style={{ margin: "auto 0px" }}>Account Properties</Typography.Title>
            </Row>
            <Card title="Capabilities" size="small">
                {_.map(_.get(properties, "capabilities", []), (capability) => (<Tag key={capability}>{capability}</Tag>))}
            </Card>
            <Card
                title="SAML Properties"
                size="small"
                extra={(
                    <CustomButton
                        type="primary"
                        enableOnlyForAdmin
                        size="small"
                        onClick={() => { updateSamlProperties(acctName, samlProperties) }}
                    >Save</CustomButton>)}
            >
                <Typography>Email Domains</Typography>
                {_.map(_.get(samlProperties, "emailDomains", []), (email, index) => {
                    if (editInputIndex === index) {
                        return (
                            <Input
                                ref={editInputRef}
                                key={email}
                                size="small"
                                value={editInputValue}
                                onChange={handleEditInputChange}
                                onBlur={handleEditInputConfirm}
                                onPressEnter={handleEditInputConfirm}
                            />
                        );
                    }
                    const tagElem = (
                        <Tag
                            key={email}
                            closable
                            style={{
                                userSelect: 'none',
                            }}
                            onClose={() => handleClose(email)}
                        >
                            <span
                                onDoubleClick={(e) => {
                                    setEditInputIndex(index);
                                    setEditInputValue(email);
                                    e.preventDefault();
                                }}
                            >
                                {email}
                            </span>
                        </Tag>
                    );
                    return tagElem;
                })}
                {inputVisible ? (
                    <Input
                        ref={inputRef}
                        type="text"
                        size="small"
                        value={inputValue}
                        onChange={handleInputChange}
                        onBlur={handleInputConfirm}
                        onPressEnter={handleInputConfirm}
                    />
                ) : (
                    <Tag style={tagPlusStyle} onClick={showInput}>
                        Add Email Domain
                    </Tag>
                )}
            </Card>
            {(cdoProperties && typeof cdoProperties === 'object' && !Array.isArray(cdoProperties) && Object.keys(cdoProperties).length > 0) ? (
                <Card size="small" title="CDO Properties">
                    <Descriptions column={1} size="small">
                        {_.map(_.get(properties, "cdoProperties", {}), (value, key) => (
                            <Descriptions.Item key={key} label={key}>{`${value}`}</Descriptions.Item>
                        ))}
                    </Descriptions>
                </Card>
            ) : <></>}
            <Card size="small" title="CDO TokenSharingInfo">
                <Descriptions column={1} size="small">
                    {_.map(_.get(properties, "cdoTokenSharingInfo", {}), (value, key) => (
                        <Descriptions.Item key={key} label={key}>{`${value}`}</Descriptions.Item>
                    ))}
                </Descriptions>
            </Card>
        </Flex>
    );
};

export default AccountProperties;